import React, { useEffect } from "react";
import QuestOne from "../../components/quote-components/quoteQuestions/QuestOne";
import { useNavContext } from "../../context-api/nav-context";

const QuestionOne = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestOne />
    </main>
  );
};

export default QuestionOne;
